export default __webpack_public_path__ + "static/media/pencil.c6f7383a.svg";